import ArticleLayout from '@/components/feature/ArticleLayout';
import { articleData } from '@/mocks/articles';

export default function ArticlePage() {
  const article = articleData['best-sugargoo-spreadsheet-2026'];
  return <ArticleLayout article={article} />;
}